module.exports = __webpack_public_path__ + "img/ups-logo.5964bf37.svg";